export const createChunkPayload = (chunk) => {
  const payload = {
    chunk_name: chunk.originalChunkName || chunk.id || `chunk-${chunk.startPage}`,
    name: chunk.name,
    startPage: chunk.startPage,
    endPage: chunk.endPage,
    page: chunk.startPage,
    level: chunk.level || 1,
    type: chunk.type || 'chapter',
    visibility: chunk.visibility || 'normal',
    preserve_visibility: chunk.preserve_visibility || false,
    copyright_holders: (chunk.copyright_holders || []).map(holder => ({
      forename: holder.forename || '',
      surname: holder.surname || '',
      prefix: holder.prefix || null,
      unique_person_id: holder.unique_person_id || null,
      id_location: holder.id_location || null,
      orcid: holder.orcid || null,
    })),
    children: []
  };

  // Include language field if explicitly set by user
  if (chunk.language) {
    payload.language = chunk.language;
  }

  // Include detected language if present (from auto-detection)
  if (chunk.detected_language) {
    payload.detected_language = chunk.detected_language;
  }

  return payload;
};

export const createProcessPayload = (doc, chunks, metadata) => {
  const totalPages = typeof doc.classificationData.document === 'object'
    ? doc.classificationData.document.page_count
    : doc.classificationData.document;

  return {
    filename: doc.classificationData.filename,
    s3_key: doc.classificationData.s3_key,
    chunks: chunks.map(createChunkPayload),
    document: {
      page_count: totalPages,
      metadata: doc.classificationData.document?.metadata || null
    },
    page_offset: metadata.page_offset
  };
};
